export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/voice_over.a6345c7.svg";